import React from 'react';
import { Box, Typography } from "@mui/material";
import BracketGameSweet16Desktop from './BracketGameSweet16Desktop';
import BracketChamp from './BracketChamp';
import "./SweetSixteenBracketDesktop.scss";
import { useUserAndGameContext } from '../../../contexts/UserAndGameContext';
import { useBracketGamesContext } from '../../BracketGames/context/BracketGamesContext';
import { round } from 'lodash';
import SweetSixteenBracket from './SweetSixteenBracket';
import AgnosticBracketGameDesktop from './AgnosticBracketGameDesktop';

const AgnosticSixteenTeamBracket = ({
    games,
    teams,
    league,
    handleGameClick,
    showDesktopNavBar,
    bracketState,
    seriesLengths,
    setSeriesLengths,
    lastRound,
    picksInfo,
    hasBracketDeadlinePassed,
}) => {
    // Removed the isPastFirstColumn state variable
    const {
        masterPoolData,
        intervalInfo,
    } = useUserAndGameContext();

    const usingSeriesLengths = masterPoolData?.gameParameters?.usingSeriesLengths;

    // Always use expanded mode by setting a constant false value instead of the state variable
    const isCompressed = false;

    return (
        <Box className="regional-bracket-desktop-container" sx={{ display:'flex', justifyContent: 'center', alignItems: 'center', width: '100%', paddingRight: '32px' }}>
            <Box className="regional-bracket-desktop">
                {/* First Round Column */}
                <Box className="regional-bracket-desktop-column regional-bracket-desktop-column-games-first">
                     <Box sx={{ width: '230px', marginBottom: '24px', paddingBottom: '30px', marginLeft: '50px' }}>
                     {showDesktopNavBar?
                        <>
                            <Typography sx={{ fontSize: '24px', fontWeight: '700' }}>{intervalInfo?.info[0]?.label}</Typography>
                            <Typography sx={{ fontSize: '18px', fontWeight: '700' }}>
                                {intervalInfo?.info[0]?.points} Point{intervalInfo?.info[0]?.points > 1 ? 's' : ''}
                            </Typography>
                            </>
                            :
                        <></>}
                    </Box>
                    <Box>
                        {Array(4).fill(null).map((_, index) => (
                            <Box key={`round1-${index}`} className="regional-bracket-desktop-game">
                                <AgnosticBracketGameDesktop
                                    matchupId={index + 1}
                                    round={1}
                                    games={games}
                                    teams={teams}
                                    league={league}
                                    handleGameClick={handleGameClick}
                                    hasBracketDeadlinePassed={hasBracketDeadlinePassed}
                                    bracketState={bracketState}
                                    seriesLengths={seriesLengths}
                                    setSeriesLengths={setSeriesLengths}
                                    hideUserPicksOutsideBoxRound={1}
                                    usingSeriesLengths={usingSeriesLengths}
                                    picksInfo={picksInfo}
                                />
                            </Box>
                        ))}
                    </Box>
                </Box>

                {/* First Round Connectors - Always use expanded class */}
                <Box className="regional-bracket-desktop-connector-column first-round-desktop">
                    {Array(2).fill(null).map((_, index) => (
                        <Box
                            key={`connector1-${index}`}
                            className="connector-wrapper-desktop first-round-desktop-expanded"
                        >
                            <div className="vertical-line-desktop" />
                        </Box>
                    ))}
                </Box>

                {/* Second Round Column */}
                <Box className="regional-bracket-desktop-column regional-bracket-desktop-column-games-second">

                    <Box sx={{ width: '230px', marginBottom: '95.5px', paddingBottom: '30px', marginLeft: '50px' }}>
                        {showDesktopNavBar?<>
                            <Typography sx={{ fontSize: '24px', fontWeight: '700' }}>{intervalInfo?.info[1]?.label}</Typography>
                            <Typography sx={{ fontSize: '18px', fontWeight: '700' }}>
                                {intervalInfo?.info[1]?.points} Point{intervalInfo?.info[1]?.points > 1 ? 's' : ''}
                            </Typography>
                        </>
                        :
                        <></>}
                    </Box>
                    <Box>
                        {Array(2).fill(null).map((_, index) => (
                            <React.Fragment key={`round2-${index}`}>
                                <Box className="regional-bracket-desktop-game">
                                    <AgnosticBracketGameDesktop
                                        matchupId={index + 9}
                                        round={2}
                                        games={games}
                                        teams={teams}
                                        league={league}
                                        handleGameClick={handleGameClick}
                                        hasBracketDeadlinePassed={hasBracketDeadlinePassed}
                                        bracketState={bracketState}
                                        seriesLengths={seriesLengths}
                                        setSeriesLengths={setSeriesLengths}
                                        usingSeriesLengths={usingSeriesLengths}
                                        picksInfo={picksInfo}
                                    />
                                </Box>
                                {/* Always use the expanded height */}
                                <Box sx={{
                                    height: '142px'
                                }} />
                            </React.Fragment>
                        ))}
                    </Box>
                </Box>

                {/* Second Round Connectors - Always use expanded class */}
                <Box className="regional-bracket-desktop-connector-column second-round">
                    {Array(1).fill(null).map((_, index) => (
                        <Box
                            key={`connector2-${index}`}
                            className="connector-wrapper-desktop second-round-expanded"
                        >
                            <div className="vertical-line-desktop" style={{
                                left:'-120px !important'
                            }} />
                        </Box>
                    ))}
                </Box>

                {/* Sweet 16 Column */}
                <Box className="regional-bracket-desktop-column regional-bracket-desktop-column-games-third left">
                <Box sx={{ width: '175px', marginBottom: '24px', paddingBottom: '291.5px', marginLeft: '50px' }}>
                {showDesktopNavBar?<>
                        <Typography sx={{ fontSize: '24px', fontWeight: '700' }}>{intervalInfo?.info[2]?.label}</Typography>
                        <Typography sx={{ fontSize: '18px', fontWeight: '700' }}>
                            {intervalInfo?.info[2]?.points} Point{intervalInfo?.info[2]?.points > 1 ? 's' : ''}
                        </Typography>
                        </>
                        :
                        <></>
                    }
                    </Box>

                    <Box>
                        {Array(1).fill(null).map((_, index) => (
                            <React.Fragment key={`round3-${index}`}>
                                <Box key={`round3-${index}`} className="regional-bracket-desktop-game" sx={{
                                        marginLeft: '-165px'
                                }}>
                                    <AgnosticBracketGameDesktop
                                        matchupId={13}
                                        round={3}
                                        games={games}
                                        teams={teams}
                                        league={league}
                                        handleGameClick={handleGameClick}
                                        hasBracketDeadlinePassed={hasBracketDeadlinePassed}
                                        bracketState={bracketState}
                                        seriesLengths={seriesLengths}
                                        setSeriesLengths={setSeriesLengths}
                                        usingSeriesLengths={usingSeriesLengths}
                                        picksInfo={picksInfo}
                                    />
                                </Box>
                                {/* Always use the expanded height */}
                                <Box sx={{
                                    height: '522.5px'
                                }} />
                            </React.Fragment>
                        ))}
                    </Box>
                </Box>
            </Box>
            <Box className="regional-bracket-desktop ">
                {/* Sweet 16 Column */}
                <Box className="regional-bracket-desktop-column regional-bracket-desktop-column-games-third right">
                 <Box sx={{ width: '230px', marginBottom: '24px', paddingBottom: '291.5px', marginLeft: '50px' }}>
                {showDesktopNavBar?<> <Typography sx={{ fontSize: '24px', fontWeight: '700' }}>{intervalInfo?.info[2]?.label}</Typography>
                        <Typography sx={{ fontSize: '18px', fontWeight: '700' }}>
                            {intervalInfo?.info[2]?.points} Point{intervalInfo?.info[2]?.points > 1 ? 's' : ''}
                        </Typography>
                        </>
                         :
                         <></>
                     }
                    </Box>

                    <Box sx={{marginRight: '-120px'}}>
                        {Array(1).fill(null).map((_, index) => (
                            <React.Fragment key={`round3-${index}`}>
                                <Box key={`round3-${index}`} className="regional-bracket-desktop-game" sx={{
                                        marginLeft: '165px'
                                }}>
                                    <AgnosticBracketGameDesktop
                                        matchupId={14}
                                        round={3}
                                        games={games}
                                        teams={teams}
                                        league={league}
                                        handleGameClick={handleGameClick}
                                        hasBracketDeadlinePassed={hasBracketDeadlinePassed}
                                        bracketState={bracketState}
                                        seriesLengths={seriesLengths}
                                        setSeriesLengths={setSeriesLengths}
                                        usingSeriesLengths={usingSeriesLengths}
                                        picksInfo={picksInfo}
                                    />
                                </Box>
                                {/* Always use the expanded height */}
                                <Box sx={{
                                    height: '522.5px'
                                }} />
                            </React.Fragment>
                        ))}
                    </Box>
                </Box>
                {/* Second Round Connectors - Always use expanded class */}
                <Box className="regional-bracket-desktop-connector-column second-round">
                    {Array(1).fill(null).map((_, index) => (
                        <Box
                            key={`connector2-${index}`}
                            className="connector-wrapper-desktop second-round-expanded"
                        >
                            <div className="vertical-line-desktop" />
                        </Box>
                    ))}
                </Box>


                {/* Second Round Column */}
                <Box className="regional-bracket-desktop-column regional-bracket-desktop-column-games-second">

                    <Box sx={{ width: '230px', marginBottom: '95.5px', paddingBottom: '30px', marginLeft: '50px' }}>
                        {showDesktopNavBar?<> <Typography sx={{ fontSize: '24px', fontWeight: '700' }}>{intervalInfo?.info[1]?.label}</Typography>
                        <Typography sx={{ fontSize: '18px', fontWeight: '700' }}>
                            {intervalInfo?.info[1]?.points} Point{intervalInfo?.info[1]?.points > 1 ? 's' : ''}
                        </Typography>
                        </>
                          :
                          <></>
                      }
                    </Box>

                    <Box>
                        {Array(2).fill(null).map((_, index) => (
                            <React.Fragment key={`round2-${index}`}>
                                <Box className="regional-bracket-desktop-game">
                                    <AgnosticBracketGameDesktop
                                        matchupId={index + 11}
                                        round={2}
                                        games={games}
                                        teams={teams}
                                        league={league}
                                        handleGameClick={handleGameClick}
                                        hasBracketDeadlinePassed={hasBracketDeadlinePassed}
                                        bracketState={bracketState}
                                        seriesLengths={seriesLengths}
                                        setSeriesLengths={setSeriesLengths}
                                        usingSeriesLengths={usingSeriesLengths}
                                        picksInfo={picksInfo}
                                    />
                                </Box>
                                {/* Always use the expanded height */}
                                <Box sx={{
                                    height: '142px'
                                }} />
                            </React.Fragment>
                        ))}
                    </Box>
                </Box>


                {/* First Round Connectors - Always use expanded class */}
                <Box className="regional-bracket-desktop-connector-column first-round-desktop">
                    {Array(2).fill(null).map((_, index) => (
                        <Box
                            key={`connector1-${index}`}
                            className="connector-wrapper-desktop first-round-desktop-expanded"
                        >
                            <div className="vertical-line-desktop" />
                        </Box>
                    ))}
                </Box>
                {/* First Round Column */}
                <Box className="regional-bracket-desktop-column regional-bracket-desktop-column-games-first-desktop-right">
                    <Box sx={{ width: '230px', marginBottom: '24px', paddingBottom: '30px', marginLeft: '50px' }}>
                         {showDesktopNavBar?<>
                        <Typography sx={{ fontSize: '24px', fontWeight: '700' }}>{intervalInfo?.info[0]?.label}</Typography>
                        <Typography sx={{ fontSize: '18px', fontWeight: '700' }}>
                            {intervalInfo?.info[0]?.points} Point{intervalInfo?.info[0]?.points > 1 ? 's' : ''}
                        </Typography>
                        </>
                         :
                         <></>
                     }
                    </Box>

                    <Box>
                        {Array(4).fill(null).map((_, index) => (
                            <Box key={`round1-${index}`} className="regional-bracket-desktop-game">
                                <AgnosticBracketGameDesktop
                                    matchupId={index + 5}
                                    round={1}
                                    games={games}
                                    teams={teams}
                                    league={league}
                                    handleGameClick={handleGameClick}
                                    hasBracketDeadlinePassed={hasBracketDeadlinePassed}
                                    bracketState={bracketState}
                                    seriesLengths={seriesLengths}
                                    setSeriesLengths={setSeriesLengths}
                                    hideUserPicksOutsideBoxRound={1}
                                    usingSeriesLengths={usingSeriesLengths}
                                    picksInfo={picksInfo}
                                />
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default AgnosticSixteenTeamBracket;